import React, { useState, useEffect, useContext, useRef } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, useLocation, useNavigationType } from "react-router-dom";
import axios from "axios";
import SideMenu from "./student/SideMenu";

import moment from "moment";
import Loader from "../components/loader";
import SweetAlert from "react-bootstrap-sweetalert";
import { contentContext } from "../context/contentContext";
import TableLoader from "../components/tableLoader";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import tmdbApi from "../api/tmdbApi";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";


const { lambda, appname } = window.app;

// list position is saved when opening view/edit so coming back returns to the same page
const LIST_POSITION_KEY = "fellowshipListPosition";
const DEFAULT_POSITION = { page: 1, perPage: 15, search: "" };
const getSavedListPosition = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(LIST_POSITION_KEY));
    return saved?.page && saved?.perPage ? { ...DEFAULT_POSITION, ...saved } : null;
  } catch {
    return null;
  }
};

const FellowshipList = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { search } = state || {};
  const navigationType = useNavigationType(); // "POP" = browser back/forward
  const [user, setUser] = useState("");
  const [perpage, setPerpage] = useState(10);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageNumberLimit, setPageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [tableErrMsg, setTableErrMsg] = useState(false);
  const [arrowdir, setArrowDir] = useState("down");
  const [num, setNum] = useState();
  const [deleteShow, setDeleteShow] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const id = localStorage.getItem("userId");
  const [flag, setFlag] = useState(false);
  const [usersearch, setUserSearch] = useState("");
  // from view/edit (Back button or browser back): restore the saved page; from any other menu: page 1
  const [initialPosition] = useState(() => ((state?.restoreListPage || navigationType === "POP") && getSavedListPosition()) || DEFAULT_POSITION);
  const [page, setPage] = useState(initialPosition.page);
  const [perPage, setPerPage] = useState(initialPosition.perPage);
  const [totalRows, setTotalRows] = useState(0);
  // true when the API paged the result; false when it sent every row (table then pages client-side)
  const [serverPaging, setServerPaging] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [activeSearch, setActiveSearch] = useState(""); // search term the loaded rows belong to
  const requestIdRef = useRef(0);

  const {
    isLoading,
    setIsLoading,
    userData,
    setUserData,
    activeMenuObj,
    setActiveMenuObj,
    sortTableAlpha,
    arrow,
    data,
    setData,
    route,
    setRoute,
    setActiveMenuId,
    GetTimeActivity,
  } = useContext(contentContext);

  const validateObj =
    userData &&
    userData.permissions &&
    userData.permissions.length > 0 &&
    userData.permissions.filter((eachItem) => eachItem.menu === "Users");
  const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard;

  const keyForRerender = `${perPage}_${data?.length}`;

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name ?? "",
      sortable: true,
    },
    {
      name: "User Type",
      selector: (row) => row?.userType ?? "",
      sortable: true,
    },
    {
      name: "Email id",
      selector: (row) => {
        const val = row?.emailid;
        if (Array.isArray(val)) {
          return val.join(", ");
        }
        if (val && typeof val === "object") {
          return val.label || val.value || "";
        }
        return val ?? "";
      },
      sortable: true,
    },
    {
      name: "Phone Number",
      selector: (row) => row?.phoneNumber ?? "",
      sortable: true,
    },
    {
      name: "Subscription Type",
      selector: (row) => row?.subscriptionTier ?? "",
    },
    {
      name: "Start Date",
      selector: (row) => row?.subscriptionStartDate,
      sortable: true,
      cell: (props) =>
        props?.subscriptionStartDate
          ? new Date(props.subscriptionStartDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          : "",
    },
    {
      name: "End Date",
      selector: (row) => row?.subscriptionEndDate,
      sortable: true,
      cell: (props) =>
        props?.subscriptionEndDate
          ? new Date(props.subscriptionEndDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          : "",
    },
    {
      name: "Pathalogist",
      selector: (row) => {
        const val = row?.assignedPathologists;
        if (Array.isArray(val)) {
          return val
            .map((item) => (typeof item === "object" ? item.label || item.value || "" : item))
            .join(", ");
        }
        if (val && typeof val === "object") {
          return val.label || val.value || "";
        }
        return val ?? "";
      },
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status ?? "",
      sortable: true,
    },
    {
      name: "Actions",
      cell: (props) => (
        <div className="d-flex">
          <a onClick={(e) => handleViewUser(e, props.userid)} className="text-success action-button" style={{ cursor: "pointer" }}>
            <i className="mdi mdi-eye font-size-18"></i>
          </a>

          <a onClick={(e) => handleEditUser(e, props.userid)} className="text-danger action-button ms-2" style={{ cursor: "pointer" }}>
            <i className="mdi mdi-pencil font-size-18"></i>
          </a>

          {/* Delete button is commented out but ready if needed */}
          {/* <a onClick={(e) => handleDeleteUser(e, props.userid)} className="text-danger action-button ms-2" style={{ cursor: "pointer" }}>
            <i className="mdi mdi-delete font-size-18"></i>
          </a> */}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const handlePageChange = (newPage) => {
    // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
    if (newPage === page) return;
    GetTimeActivity();
    setPage(newPage);
    if (serverPaging) {
      fetchFellows({ page: newPage, search: activeSearch, showLoader: false });
    }
  };

  const handlePerRowsChange = (newPerPage) => {
    if (newPerPage === perPage) return;
    GetTimeActivity();
    setPerPage(newPerPage);
    setPage(1);
    if (serverPaging) {
      fetchFellows({ page: 1, perPage: newPerPage, search: activeSearch, showLoader: false });
    }
  };

  useEffect(() => {
    setRoute("user");
    setData([]);

    if (!localStorage.getItem("token")) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    setUserSearch(initialPosition.search);
    fetchFellows({ page: initialPosition.page, perPage: initialPosition.perPage, search: initialPosition.search });
  }, []);

  // single fetch for the fellowship list and search
  const fetchFellows = ({ page = 1, perPage: size = perPage, search = "", showLoader = true }) => {
    const requestId = ++requestIdRef.current;
    showLoader ? setIsLoading(true) : setTableLoading(true);
    axios({
      method: "GET",
      url: lambda + "/userInfo?appname=" + appname + "&type=subscription&search=" + encodeURIComponent(search) + "&paginate=true&pageNumber=" + page + "&pageSize=" + size,
    })
      .then(function (response) {
        // a newer request went out while this one was in flight - drop this response
        if (requestId !== requestIdRef.current) return;

        if (response?.data?.result === "Invalid token or Expired") {
          setIsLoading(false);
          setTableLoading(false);
          setShowSessionPopupup(true);
        } else {
          const result = response?.data?.result;
          // paged response is { data, totalCount }; a plain array means the API sent every row
          const backendPaged = !Array.isArray(result);
          const rows = (backendPaged ? result?.data : result) ?? [];

          // page is past the end (e.g. last row on the page was deleted) - step back one page
          if (backendPaged && rows.length === 0 && page > 1) {
            setPage(page - 1);
            fetchFellows({ page: page - 1, perPage: size, search, showLoader });
            return;
          }

          if (!search) setUser(rows);
          setData(rows);
          global.exportExcelData = rows;
          setServerPaging(backendPaged);
          setTotalRows(backendPaged ? (result?.totalCount ?? rows.length) : rows.length);
          setActiveSearch(search);

          setIsLoading(false);
          setTableLoading(false);
        }
      })
      .catch((err) => {
        if (requestId !== requestIdRef.current) return;
        console.log("error", err);
        setTableErrMsg(true);
        setIsLoading(false);
        setTableLoading(false);
      });
  };

  const saveListPosition = () => {
    localStorage.setItem(LIST_POSITION_KEY, JSON.stringify({ page, perPage, search: activeSearch }));
  };

  const handleSearch = (e, flagggg) => {
    GetTimeActivity();

    const inputQuery = usersearch;

    // ✅ Empty / whitespace-only validation
    if (inputQuery.trim().length === 0) {
      toast.error("Search field cannot be empty.");
      return;
    }

    setFlag(true);
    setPage(1);
    fetchFellows({ page: 1, search: inputQuery });
  };

  const handleChange = (e) => {
    if (e.target.value === "") {
      setFlag(false);
    }
    setUserSearch(e.target.value);
  };

  const handleKeypress = (e) => {
    GetTimeActivity();
    if (e.key === "Enter") {
      handleSearch(e, "normalsearch");
    }
  };

  const handleEditUser = (e, paramuserid) => {
    saveListPosition();
    navigate("/editfellows/" + paramuserid);
  };

  const handleDeleteUser = (e, paramuserid) => {
    setDeleteUserId(paramuserid);
    setDeleteShow(true);
  };

  const onDeleteCancel = () => {
    setDeleteShow(false);
    setDeleteUserId(null);
  };

  const onDeletePopupClose = () => {
    setDeleteSuccess(false);
    setDeleteUserId(null);
    fetchFellows({ page, search: activeSearch, showLoader: false });
  };

  const handleDelete = async () => {
    setDeleteShow(false);
    try {
      await tmdbApi.userDelete(deleteUserId);
      setDeleteSuccess(true);
    } catch {
      console.log("error");
    }
  };

  const handleViewUser = (e, paramuserid) => {
    GetTimeActivity();
    saveListPosition();
    navigate("/viewfellows/" + paramuserid);
  };

  const clearSearch = () => {
    GetTimeActivity();
    setUserSearch("");
    setFlag(false);
    setPage(1);
    fetchFellows({ page: 1 });
  };

  const customNoRecords = () => {
    return (
      <div className="empty-state-body empty-record">
        <div className="empty-state__message">
          <span className="material-icons">summarize</span>
          <p className="form-check font-size-16">No fellowships were found</p>
        </div>
      </div>
    );
  };

  const handleExport = () => {
    const modifiedArray = global.exportExcelData.map((each, i) => ({
      "S.NO": i + 1,
      NAME: each?.name ?? "",
      "USER TYPE": each?.userType ?? "",
      "EMAIL ID":
        typeof each?.emailid === "object" &&
          each?.emailid !== null &&
          each?.emailid.length > 1
          ? each.emailid.join(", ")
          : each?.emailid ?? "",
      "PHONE NUMBER": each?.phone ?? "",
      STATUS: each?.status ?? "",
    }));

    exportToExcel(modifiedArray, "data");
  };

  function exportToExcel(jsonData, fileName) {
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data1 = new Blob([excelBuffer], { type: "application/octet-stream" });
    FileSaver.saveAs(data1, `UsersData.xlsx`);
  }

  const customSort = (rows, selector, direction) => {
    const sortedData = rows.slice().sort((rowA, rowB) => {
      const aField = String(selector(rowA)).toLowerCase();
      const bField = String(selector(rowB)).toLowerCase();

      let comparison = 0;
      if (aField > bField) comparison = 1;
      else if (aField < bField) comparison = -1;

      return direction === "desc" ? comparison * -1 : comparison;
    });

    global.exportExcelData = sortedData;
    return sortedData;
  };

  return (
    <>
      <div id="layout-wrapper">
        <Header />
        <SideMenu />
        <div className="main-content user-management fellowship-db-page" id="main-content">
          <div className="page-content" id="page-content">
            <div className="container-fluid" id="container-fluid">
              <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                <div className="col-lg-12">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h4 className="mb-2 card-title" id="breadcrumb-title">
                        Fellowships
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row table-data" id="table-data-row">
                <div className="col-12">
                  <div className="card" id="card">
                    <div className="card-body" id="card-body">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <>
                          <div className="row mb-2" id="table-header-row">
                            <div className="col-sm-4 button-block" id="button-block"></div>
                            <div className="col-sm-8">
                              <div
                                className="search-box mb-2 d-inline-block"
                                id="search-box"
                              >
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={usersearch}
                                    onChange={handleChange}
                                    placeholder="Search by Name or Email"
                                    onKeyPress={handleKeypress}
                                    id="search-input"
                                  />
                                  <button
                                    className="fill_btn"
                                    onClick={(e) => handleSearch(e, "normalsearch")}
                                    id="search-btn"
                                  >
                                    <span className="material-icons search-icon">
                                      search
                                    </span>
                                  </button>
                                </div>
                                <div
                                  className="dataTables_length"
                                  id="datatable-length-reset"
                                >
                                  <button
                                    className="fill_btn"
                                    onClick={clearSearch}
                                    id="reset-btn"
                                  >
                                    <span className="material-icons-outlined">sync</span>
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <DataTable
                            key={keyForRerender}
                            columns={columns}
                            keyField="_id"
                            data={data}
                            direction="auto"
                            highlightOnHover
                            fixedHeaderScrollHeight="300px"
                            pagination
                            paginationServer={serverPaging}
                            responsive
                            persistTableHead
                            striped
                            subHeaderAlign="right"
                            defaultSortField="name"
                            noDataComponent={customNoRecords()}
                            paginationTotalRows={totalRows}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            paginationPerPage={perPage}
                            paginationDefaultPage={page}
                            paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                            sortFunction={customSort}
                            paginationComponentOptions={{
                              rowsPerPageText: "Per page:",
                              rangeSeparatorText: "of",
                              noRowsPerPage: false,
                              selectAllRowsItem: false,
                              selectAllRowsItemText: "All",
                            }}
                            progressPending={tableLoading}
                            progressComponent={<TableLoader />}
                            id="data-table"
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <SweetAlert
            show={tableErrMsg}
            custom
            confirmBtnText="ok"
            confirmBtnBsStyle="primary"
            title={"Something went wrong. Please reload again."}
            onConfirm={() => setTableErrMsg(false)}
            id="error-alert"
          ></SweetAlert>

          <SweetAlert
            show={deleteShow}
            warning
            showCancel
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title="Are you sure you want to delete?"
            focusCancelBtn
            onConfirm={handleDelete}
            onCancel={onDeleteCancel}
          ></SweetAlert>

          <SweetAlert
            show={deleteSuccess}
            custom
            confirmBtnText="ok"
            confirmBtnBsStyle="primary"
            title={"Deleted Successfully"}
            onConfirm={onDeletePopupClose}
          ></SweetAlert>

          {/* ✅ Toast container should be here */}
          <ToastContainer
            position="bottom-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable
          />

          <Footer id="footer" />
        </div>
      </div>
    </>
  );
};

export default FellowshipList;